export default {
  mounted() {
    document.addEventListener('keydown', this.onKeyDown);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.onKeyDown);
  },
  methods: {
    onKeyDown(e) {
      if (e.code === 'Space' && this[this.onSpaceHandler]) {
        this[this.onSpaceHandler]();
      }
    },
  },
};
